import { render, staticRenderFns } from "./auth-sign-up.vue?vue&type=template&id=9090ecf0&"
import script from "./auth-sign-up.vue?vue&type=script&lang=js&"
export * from "./auth-sign-up.vue?vue&type=script&lang=js&"
import style0 from "./auth-sign-up.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports